import { render } from "./Types.vue?vue&type=template&id=538c7e81&scoped=true"
import script from "./Types.vue?vue&type=script&lang=js"
export * from "./Types.vue?vue&type=script&lang=js"

import "./Types.vue?vue&type=style&index=0&id=538c7e81&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538c7e81"]])

export default __exports__